export type IssueCategory = { name: string; share: number };

export const issueDistribution: IssueCategory[] = [
  { name: "System configuration & pay rules", share: 29 },
  { name: "Integrations & data feeds", share: 21 },
  { name: "Process & approvals", share: 18 },
  { name: "Employee data quality", share: 13 },
  { name: "Tax filing & registration", share: 11 },
  { name: "Vendor support & escalation", share: 8 },
];

export type Benchmark = {
  metric: string;
  suffix: string;
  lowerIsBetter: boolean;
  min: number;
  max: number;
  p25: number;
  median: number;
  p75: number;
  leaders: number;
};

export const benchmarks: Benchmark[] = [
  { metric: "First-pass payroll accuracy", suffix: "%", lowerIsBetter: false, min: 95, max: 100, p25: 97.4, median: 98.6, p75: 99.3, leaders: 99.8 },
  { metric: "Off-cycle payrolls per 1,000 employees, per year", suffix: "", lowerIsBetter: true, min: 0, max: 30, p25: 7, median: 12, p75: 19, leaders: 3 },
  { metric: "Manual adjustments per cycle, per 1,000 employees", suffix: "", lowerIsBetter: true, min: 0, max: 60, p25: 15, median: 27, p75: 41, leaders: 8 },
  { metric: "Business days from period close to pay date", suffix: "", lowerIsBetter: true, min: 0, max: 8, p25: 2.5, median: 4, p75: 5.5, leaders: 2 },
];

export type MaturityDimension = { name: string; score: number; peerMedian: number };

export const maturityProfile: MaturityDimension[] = [
  { name: "Governance", score: 4.2, peerMedian: 3.1 },
  { name: "Process", score: 3.8, peerMedian: 3.0 },
  { name: "Technology", score: 4.4, peerMedian: 3.4 },
  { name: "Controls", score: 3.6, peerMedian: 2.8 },
  { name: "Documentation", score: 3.9, peerMedian: 2.6 },
];

export type OperationsMetric = {
  label: string;
  note: string;
  value: string;
  direction: "up" | "down" | "flat";
  series: number[];
};

export const operationsHealth: OperationsMetric[] = [
  { label: "Payroll accuracy", note: "First pass, no corrections", value: "99.8%", direction: "flat", series: [98.1, 98.4, 98.3, 98.9, 99.1, 99.0, 99.4, 99.5, 99.6, 99.7, 99.7, 99.8] },
  { label: "Off-cycle payrolls", note: "vs. prior 12 cycles", value: "64%", direction: "down", series: [11, 10, 12, 9, 8, 8, 6, 5, 5, 4, 4, 4] },
  { label: "Manager approval rate", note: "Approved before cutoff", value: "96%", direction: "flat", series: [81, 83, 82, 86, 88, 90, 91, 93, 94, 95, 95, 96] },
  { label: "Manual adjustments", note: "vs. prior 12 cycles", value: "41%", direction: "down", series: [34, 33, 35, 31, 29, 28, 26, 24, 23, 22, 21, 20] },
];
